<template>
    <div>
        <crud-table
            ref="table"

            api="portal_field_definitions"

            label="Portal-Felder"
            :name="{singular: 'Portal-Feld', plural: 'Portal-Felder'}"

            v-on:add="openForm"
            v-on:edit="openForm"
            @dataLoaded="data => $store.commit('updateData', {portalFields: data})"

            :filter="params"

            :columns="columns"
        >
            <h2 slot="header">Individuelle Felder</h2>

            <template v-slot:entityType="slotProps">
                {{ entityTypeLabel(slotProps.row.entityType) }}
            </template>

            <template v-slot:type="slotProps">
                {{ typeLabel(slotProps.row.type) }}
            </template>

            <template v-slot:source="slotProps">
                {{ sourceLabel(slotProps.row.source) }}
            </template>

            <template v-slot:active="slotProps">
                <i v-if="slotProps.row.active" class="material-icons">check</i>
            </template>

            <item-form
                slot="form"
                formType="modal"
                ref="form"
                v-on:success="$refs.table.refresh()"
            />

            <template v-slot:footer>
                <div class="level level-left">
                    <a
                        v-on:click="openForm"
                        class="button level-item is-primary"
                    >Feld hinzufügen</a>
                </div>
            </template>
        </crud-table>
    </div>
</template>

<script>
import Mixin from '../tab';
import ItemForm from './Form';
import { CrudTable } from '@components/CRUD';
import { ENTITY_TYPE_OPTIONS, TYPE_OPTIONS } from './options';

export default {
    mixins: [Mixin],

    data: function () {
        return {
            columns: [
                { key: 'entityType', label: 'Ebene', class: 'has-border is-110px-cell is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'label', label: 'Label', class: 'has-border is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', formElement: 'PureText' },
                { key: 'fieldKey', label: 'Key', class: 'has-border is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', formElement: 'PureText' },
                { key: 'type', label: 'Typ', class: 'has-border is-90px-cell is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'source', label: 'Quelle', class: 'has-border is-90px-cell is-pure-text is-ellipsis', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'sortOrder', label: 'Reihenfolge', class: 'has-border is-90px-cell is-pure-text has-text-centered', style: 'flex-grow:1;flex-shrink:1', formElement: 'PureText' },
                { key: 'width', label: 'Breite', class: 'has-border is-60px-cell is-pure-text has-text-centered', style: 'flex-grow:1;flex-shrink:1', sortable: false },
                { key: 'active', label: 'Aktiv', class: 'has-border is-icon-cell is-ellipsis has-text-centered', style: 'flex-grow:1;flex-shrink:1', sortable: false },
            ],
        };
    },

    computed: {
        params() {
            return {
                'client.id': this.item.id,
                '_order[entityType]': 'ASC',
                '_order[sortOrder]': 'ASC',
            };
        },
    },

    methods: {
        entityTypeLabel(value) {
            const option = ENTITY_TYPE_OPTIONS.find(item => item.key === value);
            return option ? option.value : value;
        },

        typeLabel(value) {
            const option = TYPE_OPTIONS.find(item => item.key === value);
            return option ? option.value : value;
        },

        sourceLabel(value) {
            if (value === 'computed') return 'berechnet';
            if (value === 'entity') return 'Standard';
            return 'manuell';
        },
    },

    activated: function () {
        this.$refs.table.refresh();
    },

    components: {
        CrudTable,
        ItemForm,
    },
};
</script>
